import React from 'react';
import styles from './Segundaparte.module.css';

import icon1 from '../../../../utils/images/smartsen_1.svg';
import icon2 from '../../../../utils/images/smartsen_2.svg';
import icon3 from '../../../../utils/images/smartsen_3.svg';
import icon4 from '../../../../utils/images/smartsen_4.svg';

const SegundaParte = ({ t }) => {
  return (
    <section className={styles.container}>
      <h2 className={styles.title}>
        {t('Products.Smartsen.SecondPart.title')}
      </h2>

      <p className={styles.intro}>
        {t('Products.Smartsen.SecondPart.intro')}
      </p>

      <div className={styles.grid}>
        <div className={styles.item}>
          <img src={icon1} alt="" className={styles.icon} />
          <p className={styles.itemTitle}>
            {t('Products.Smartsen.SecondPart.text')}
          </p>
          <p className={styles.itemText}>
            {t('Products.Smartsen.SecondPart.text2')}
          </p>
        </div>

        <div className={styles.item}>
          <img src={icon2} alt="" className={styles.icon} />
          <p className={styles.itemTitle}>
            {t('Products.Smartsen.SecondPart.text3')}
          </p>
          <p className={styles.itemText}>
            {t('Products.Smartsen.SecondPart.text4')}
          </p>
        </div>

        <div className={styles.item}>
          <img src={icon3} alt="" className={styles.icon} />
          <p className={styles.itemTitle}>
            {t('Products.Smartsen.SecondPart.text5')}
          </p>
          <p className={styles.itemText}>
            {t('Products.Smartsen.SecondPart.text6')}
          </p>
        </div>

        <div className={styles.item}>
          <img src={icon4} alt="" className={styles.icon} />
          <p className={styles.itemTitle}>
            {t('Products.Smartsen.SecondPart.text7')}
          </p>
          <p className={styles.itemText}>
            {t('Products.Smartsen.SecondPart.text8')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default SegundaParte;
